import { render, staticRenderFns } from "./batch-list.vue?vue&type=template&id=25693ae4&scoped=true&"
import script from "./batch-list.vue?vue&type=script&lang=js&"
export * from "./batch-list.vue?vue&type=script&lang=js&"
import style0 from "./batch-list.vue?vue&type=style&index=0&id=25693ae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25693ae4",
  null
  
)

export default component.exports